import { FaultType } from '@app/services/fault-report.interface';

/** Human labels for the fault-type select, ordered most common first. */
export const FAULT_TYPES: Record<FaultType, string> = {
  [FaultType.WONT_START]: "Won't start",
  [FaultType.CABLE_DAMAGED]: 'Cable damaged',
  [FaultType.SCREEN_ERROR]: 'Screen error',
  [FaultType.PAYMENT_FAILED]: 'Payment failed',
  [FaultType.PHYSICALLY_BLOCKED]: "Blocked / ICE'd",
  [FaultType.SLOW_CHARGE]: 'Charging slow',
  [FaultType.CONNECTOR_STUCK]: 'Connector stuck',
  [FaultType.OTHER]: 'Other',
};
